import { createAction, props } from '@ngrx/store';
import { DataItem, TestItem } from './data.model';

export const loadLocalData = createAction('[Data] Load Local Data', props<{ data: DataItem[] }>());

export const loadLocalTest = createAction('[Test] Load Local Test', props<{ test: TestItem[] }>());